import type { OfferingCardData, OfferingSection } from '../data/demoData';

const MAX_CARDS_PER_SHELF = 4;

export const allocatePreviewSections = (
  candidateSections: OfferingSection[],
): OfferingSection[] => {
  const claimed = new Set<string>();
  return candidateSections.map((section) => {
    const cards: OfferingCardData[] = [];
    section.cards.forEach((card) => {
      if (cards.length >= MAX_CARDS_PER_SHELF || claimed.has(card.co)) return;
      claimed.add(card.co);
      cards.push(card);
    });
    return { ...section, cards };
  });
};

export const buildCatalogPreviewSections = (
  liveSections: OfferingSection[],
  catalogSections: OfferingSection[],
): OfferingSection[] => {
  const catalogByTitle = new Map(catalogSections.map((section) => [section.title, section]));
  const candidateSections = liveSections.map(
    (section) => catalogByTitle.get(section.title) ?? section,
  );
  const trendingCards =
    candidateSections.find((section) => section.title === 'Trending now')?.cards ?? [];

  return candidateSections.map((section) => {
    if (section.title !== 'Low minimum offerings') return section;

    const lowMinimumBySlug = new Map(section.cards.map((card) => [card.co, card]));
    const seen = new Set<string>();
    const cards = [...trendingCards, ...section.cards].flatMap((card) => {
      const lowMinimumCard = lowMinimumBySlug.get(card.co);
      if (!lowMinimumCard || seen.has(card.co)) return [];
      seen.add(card.co);
      return [lowMinimumCard];
    });
    return { ...section, cards };
  });
};
